import {useParams} from 'react-router-dom';
import {useSnackbar} from "../../../context/SnackbarContext/SnackbarContext";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {API_URL, APP_URL} from "../../../config";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import AmountControl from "../../../components/AmountControl/AmountControl";
import Chip from "@mui/material/Chip";
import {getPayoutService} from "../../../services/payoutService";

const usePayoutDetails = () => {

    const {id} = useParams();

    const { showSnackbar } = useSnackbar();

    const [isLoading, setIsLoading] = useState(true);

    const [payout, setPayout] = useState(null);

    useEffect(() => {
        const init = async () => {
            setIsLoading(true);
            await loadPayout();
            setIsLoading(false);
        };

        init();
    }, []);

    const loadPayout = async () => {

        try {

            const response = await getPayoutService(id);

            setPayout(response.data.data);

        } catch (error) {

            showSnackbar('Pagos', 'Ocurrió un error cargando el pago', 'cancel', 'warning');
        }

    };

    const renderSales = () => {
        return payout.sales.map((sale, index) => {

            return <MDBox py={2} sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', borderBottomStyle: 'dashed', borderBottomWidth: index !== payout.sales.length - 1 ? 1 : 0, borderBottomColor: '#ececec'}}>
                <MDBox sx={{flexGrow: 1}}>
                    <MDTypography variant="h6">{sale.id}</MDTypography>
                    {/*<MDTypography variant="body2" sx={{fontSize: 14}}>{saleItem.product.brand}</MDTypography>*/}
                </MDBox>
                {/*<MDBox px={2} py={0.5} sx={{borderStyle: 'solid', borderWidth: 1, borderColor: '#ececec', borderRadius: 2}}>*/}
                {/*    <MDTypography variant="body2" fontWeight="400">{saleItem.quantity} x ${saleItem.price} MXN</MDTypography>*/}
                {/*</MDBox>*/}
                {/*<MDBox px={2} py={0.5}>*/}
                {/*    <MDTypography variant="body2" fontWeight="medium">${saleItem.quantity * saleItem.price} MXN</MDTypography>*/}
                {/*</MDBox>*/}
            </MDBox>
        });
    };

    const renderStatusChip = (status) => {
        switch (status) {
            case 'in_transit':
                return <Chip size="small" color="secondary" label="Preparando"
                             variant="outlined"/>;
            case 'paid':
                return <Chip size="small" color="success" label="Pagado"
                             variant="outlined"/>;
        }
    };

    return {
        id,
        isLoading,
        payout,
        renderSales,
        renderStatusChip
    };
};

export default usePayoutDetails;
